import { useEffect, useState } from 'react';
import api from '../../../../services/api';
import { Container, ContainerInternoCheck } from '../../styles';
import RModal from '../../../../components/Rsuite/Modal';
import { CustomButton } from '../../../../components/CustomButton';
import { CustomToggle } from '../../../../components/CustomToggle';
import { useCustomTheme } from '../../../../hooks/useCustomTheme';
import { toastSuccess } from '../../../../toasts';

export default function DataAgendamento({
  modal,
  fecharModal,
  IdConfig,
  DiasAgendamento,
  refresh,
}) {
  const [seg, setSeg] = useState(false);
  const [ter, setTer] = useState(false);
  const [qua, setQua] = useState(false);
  const [qui, setQui] = useState(false);
  const [sex, setSex] = useState(false);
  const [sab, setSab] = useState(false);
  const [dom, setDom] = useState(false);
  const { theme } = useCustomTheme();

  const salvar = async () => {
    const dias = {
      seg: seg,
      ter: ter,
      qua: qua,
      qui: qui,
      sex: sex,
      sab: sab,
      dom: dom,
    };
    await api
      .post('configuracao/salvarDiasAgendamento', {
        Dias: JSON.stringify(dias),
        Id: IdConfig,
      })
      .then(() => {
        toastSuccess('Salvo com sucesso!');
        fecharModal();
        refresh();
      });
  };

  useEffect(() => {
    if (DiasAgendamento) {
      setSeg(DiasAgendamento.seg);
      setTer(DiasAgendamento.ter);
      setQua(DiasAgendamento.qua);
      setQui(DiasAgendamento.qui);
      setSex(DiasAgendamento.sex);
      setSab(DiasAgendamento.sab);
      setDom(DiasAgendamento.dom);
    }
  }, [DiasAgendamento, modal]);

  const Label = ({ label = '', ...rest }) => (
    <label
      className="form-check-label"
      style={{ color: theme.colors.textSecondary }}
      {...rest}
    >
      {label}
    </label>
  );

  return (
    <RModal
      open={modal}
      onClose={fecharModal}
      title="Dias disponíveis para agendamento"
      footer={
        <>
          <CustomButton onClick={salvar} appearance="primary">
            Salvar
          </CustomButton>
          <CustomButton onClick={fecharModal} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <Container
        style={{ flexDirection: 'column', gap: 10, padding: '0 4px 0 20px' }}
      >
        <ContainerInternoCheck
          style={{ width: '100%', justifyContent: 'space-between' }}
        >
          <Label htmlFor="setSeg" label="Segunda" />
          <CustomToggle
            id="setSeg"
            checked={seg}
            onChange={() => setSeg(!seg)}
          />
        </ContainerInternoCheck>
        <ContainerInternoCheck
          style={{ width: '100%', justifyContent: 'space-between' }}
        >
          <Label label="Terça" htmlFor="setTer" />
          <CustomToggle
            id="setTer"
            checked={ter}
            onChange={() => setTer(!ter)}
          />
        </ContainerInternoCheck>
        <ContainerInternoCheck
          style={{ width: '100%', justifyContent: 'space-between' }}
        >
          <Label htmlFor="setQua" label="Quarta" />
          <CustomToggle
            id="setQua"
            checked={qua}
            onChange={() => setQua(!qua)}
          />
        </ContainerInternoCheck>
        <ContainerInternoCheck
          style={{ width: '100%', justifyContent: 'space-between' }}
        >
          <Label label="Quinta" htmlFor="setQui" />
          <CustomToggle
            id="setQui"
            checked={qui}
            onChange={() => setQui(!qui)}
          />
        </ContainerInternoCheck>
        <ContainerInternoCheck
          style={{ width: '100%', justifyContent: 'space-between' }}
        >
          <Label htmlFor="setSex" label="Sexta" />
          <CustomToggle
            id="setSex"
            checked={sex}
            onChange={() => setSex(!sex)}
          />
        </ContainerInternoCheck>
        <ContainerInternoCheck
          style={{ width: '100%', justifyContent: 'space-between' }}
        >
          <Label htmlFor="setSab" label="Sábado" />
          <CustomToggle
            id="setSab"
            checked={sab}
            onChange={() => setSab(!sab)}
          />
        </ContainerInternoCheck>
        <ContainerInternoCheck
          style={{ width: '100%', justifyContent: 'space-between' }}
        >
          <Label htmlFor="setDom" label="Domingo" />
          <CustomToggle
            id="setDom"
            checked={dom}
            onChange={() => setDom(!dom)}
          />
        </ContainerInternoCheck>
      </Container>
    </RModal>
  );
}
